<div class="pagetitle">
  <h2>List Customer</h2>
  <a [routerLink]="['/dashboard/customer/new']" class="btn btn-sm btn-outline-success"><i class="fa fa-fw fa-plus"></i> Create new customer</a>
</div>
<alert></alert>
<div class="filter form-row">
  <div class="col-md-6">
    <form [formGroup]="recordLimitForm" class="float-left" novalidate>
      <select class="form-control form-control-sm" formControlName="recordlimit" (change)="updateRecords($event.target.value)">
        @for (option of pagination['options']; track option) {
          <option value="{{option.key}}">{{option.value}}</option>
        }
      </select>
    </form>
  </div>
  <div class="col-md-6">
    <form [formGroup]="customerSearchForm" class="float-right" novalidate>
      <input type="text" class="form-control form-control-sm" formControlName="customerName" placeholder="Customer name" />
      @if (filter) {
        <i class="fa fa-fw fa-times" (click)="getCustomers()"></i>
      }
      @if (!filter) {
        <i class="fa fa-fw fa-search"></i>
      }
    </form>
  </div>
</div>
<div class="table-responsive">
  <table class="table table-bordered table-striped table-sm table-hover" id="dataTable" width="100%" cellspacing="0">
    <thead>
      <tr>
        <th width="200" [index]="0" [resizeColumn]="true" (click)="sort(sortMethodTypes.CUSTOMER_NAME)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.CUSTOMER_NAME, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.CUSTOMER_NAME && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.CUSTOMER_NAME && sortDirection === 'DESC') }">Customer Name</th>

        @if (auth.hasAccess('SuperAdmin')) {
          <th width="200" [index]="0" [resizeColumn]="true" (click)="sort(sortMethodTypes.PARTNER)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.PARTNER, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.PARTNER && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.PARTNER && sortDirection === 'DESC') }">Partner</th>
        }

        <th width="" [index]="1" [resizeColumn]="true" (click)="sort(sortMethodTypes.EMAIL)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.EMAIL, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.EMAIL && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.EMAIL && sortDirection === 'DESC') }">Email</th>

        <th width="70" [index]="2" [resizeColumn]="true" class="text-center sort-na">Status</th>

        <th width="130" [index]="3" [resizeColumn]="true" class="sort-na">Phone</th>

        <th width="100" [index]="4" [resizeColumn]="true" (click)="sort(sortMethodTypes.COUNTRY)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.COUNTRY, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.COUNTRY && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.COUNTRY && sortDirection === 'DESC') }">Country</th>

        <th width="200" [index]="5" [resizeColumn]="true" class="sort-na">Action</th>
      </tr>
    </thead>
    <tbody>

      @if ((!customers && loading) || (customers && customers.length === 0)) {
        <tr>
          <td colspan="7" class="loading text-center">
            <span class="">{{msg}}</span>
          </td>
        </tr>
      }
      @for (customer of customers; track customer; let i = $index) {
        <tr data-id="{{customer.id}}">
          <td><a [routerLink]="['/dashboard/customer/view', customer.id]" [state]="{ data: { customer: customer }}" title="View Customer">{{customer.name}}</a></td>
          @if (auth.hasAccess('SuperAdmin')) {
            <td>{{customer.partner?.name}}</td>
          }
          <td>{{customer.email}}</td>
          <td class="text-center">
            @if (customer.status=='active') {
              <span class="badge badge-success">{{customer.status}}</span>
            }
            @if (customer.status=='inactive') {
              <span class="badge badge-secondary">{{customer.status}}</span>
            }
            @if (customer.status=='DIP') {
              <span class="badge badge-danger" placement="bottom" ngbTooltip="Customer deletion is in progress.">DIP</span>
            }
          </td>
          <td>{{customer.phone}}</td>
          <td class="ellepsis" title="{{customer.country}}">{{customer.country}}</td>
          <td class="text-center">
            <a class="btn btn-assign btn-xs" href="javascript:;" title="View UUID" placement="left"
              ngbPopover="{{customer.id}}" [autoClose]="'outside'" popoverTitle="Customer UUID"><i class="fa fa-fw fa-eye"></i> UUID</a> &nbsp;
              <a class="btn btn-edit btn-xs" [routerLink]="['/dashboard/customer/edit/',(customer.id)]" [state]="{ data: { view: 'edit', customer: customer }}" title="Edit Customer"><i class="fa fa-fw fa-edit"></i> Edit</a> &nbsp;
              <a class="btn btn-delete btn-xs" href="javascript:;" (click)="deleteCustomer(customer)" title="Delete Customer"><i class="fa fa-fw fa-trash"></i> Delete</a>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <!-- Pagination Interface -->
    @if (pagination['show']) {
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item"><a class="page-link" [ngClass]="(currentPage == 1 ) ? 'disabled' : ''" href="javascript:;" (click)="paginate('previous')">Previous</a></li>
          <li class="page-item"><a class="page-link text" href="javascript:;">Page {{currentPage}} of {{pagination['pages']}}</a></li>
          <li class="page-item"><a class="page-link" [ngClass]="(currentPage == pagination['pages'] ) ? 'disabled' : ''" href="javascript:;" (click)="paginate('forward')">Next</a></li>
        </ul>
      </nav>
    }
  </div>